module.exports = __webpack_public_path__ + "img/plus.cd9e0c86.svg";